import React from 'react';
import { InvoiceTemplateProps } from './types';
import Header from './primitives/Header';
import InvoiceTitle from './primitives/Title';
import PatientInfo from './primitives/PatientInfo';
import InvoiceDetails from './primitives/InvoiceDetails';
import ItemsTable from './primitives/ItemsTable';
import Totals from './primitives/Totals';
import Footer from './primitives/Footer';

export default function Template5_CustomerCopy({ invoice, hospital }: InvoiceTemplateProps) {
  return (
    <div 
      className="invoice-root bg-white max-w-[210mm] mx-auto"
      style={{
        fontFamily: 'Inter, "Noto Sans Bengali", Arial, sans-serif',
      }}
    >
      {/* Customer Copy */}
      <div className="border-4 border-blue-600 p-6 mb-8">
        <div className="bg-blue-600 text-white text-center py-2 -mx-6 -mt-6 mb-4">
          <h3 className="text-lg font-bold">CUSTOMER COPY</h3>
        </div>
        
        <Header hospital={hospital} showLogo={true} variant="centered" />
        <InvoiceTitle />

        <div className="grid grid-cols-2 gap-8 mb-3">
          <PatientInfo invoice={invoice} layout="column" />
          <InvoiceDetails invoice={invoice} />
        </div>
        
        <ItemsTable items={invoice.items} variant="minimal" />
        
        <Totals invoice={invoice} layout="inline" showPaymentInfo={true} />
        
        {invoice.status === 'paid' && (
          <div className="text-center mt-4">
            <div className="inline-block border-4 border-green-600 px-8 py-2 transform rotate-12">
              <span className="text-3xl font-bold text-green-600">PAID</span>
            </div>
          </div>
        )}
        
        <div className="mt-6 text-xs text-gray-600 text-center">
          <p>Thank you for your business!</p>
        </div>
      </div>

      {/* Lab Copy */}
      <div className="border-4 border-gray-400 p-6 page-break-before">
        <div className="bg-gray-600 text-white text-center py-2 -mx-6 -mt-6 mb-4">
          <h3 className="text-lg font-bold">LAB COPY</h3>
        </div>
        
        <Header hospital={hospital} showLogo={true} variant="centered" />
        <InvoiceTitle />

        <div className="grid grid-cols-2 gap-8 mb-3">
          <PatientInfo invoice={invoice} layout="column" />
          <InvoiceDetails invoice={invoice} />
        </div>
        
        <ItemsTable items={invoice.items} variant="minimal" />
        
        <Totals invoice={invoice} layout="inline" showPaymentInfo={false} />
        
        <div className="mt-6 text-xs text-gray-600">
          <p>Internal use only - Not for customer</p>
        </div>
      </div>
    </div>
  );
}
